export class ContentFlightHotel {
  overlayImage: string;
  name: string;
  description: string;
  descriptionOther: string;
  flightOnlyButtonLabel: string;
  externalLinkButtonLabel: string;
  travelplusDomain: string;
  travelplusCarDomain: string;
  disclaimer: string;
  carDisclaimer: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['overlayImage']) {
        this.overlayImage = contentjson['overlayImage'];
      }
      if (contentjson['name']) {
        this.name = contentjson['name'];
      }
      if (contentjson['description']) {
        this.description = contentjson['description'];
      }
      if (contentjson['descriptionOther']) {
        this.descriptionOther = contentjson['descriptionOther'];
      }
      if (contentjson['flightOnlyButtonLabel']) {
        this.flightOnlyButtonLabel = contentjson['flightOnlyButtonLabel'];
      }
      if (contentjson['externalLinkButtonLabel']) {
        this.externalLinkButtonLabel = contentjson['externalLinkButtonLabel'];
      }
      if (contentjson['travelplusDomain']) {
        this.travelplusDomain = contentjson['travelplusDomain'];
      }
      if (contentjson['travelplusCarDomain']) {
        this.travelplusCarDomain = contentjson['travelplusCarDomain'];
      }
      if (contentjson['disclaimer']) {
        this.disclaimer = contentjson['disclaimer'];
      } else {
        this.disclaimer = '';
      }
      if (contentjson['carDisclaimer']) {
        this.carDisclaimer = contentjson['carDisclaimer'];
      } else {
        this.carDisclaimer = '';
      }
    }
  }
}
